import Container from 'react-bootstrap/Container';
import Reveal from '../atoms/Reveal';
import { numeros } from '../content/site';

/** Faixa de atributos entre o herói e o "como funciona". Não são métricas de
 *  negócio — quantidade de clientes e volume de pedidos mudam toda semana e
 *  envelheceriam na página. São quatro fatos do produto. */
function StatStrip() {
  return (
    <section className="section--alt">
      <Container className="shell">
        <div className="stat-strip py-5">
          {numeros.map((n, i) => (
            <Reveal as="div" className="stat-item" stagger={i} key={n.rotulo}>
              <span className="stat-value">{n.valor}</span>
              <span className="stat-label">{n.rotulo}</span>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default StatStrip;
